import * as ActionType from "./ActionType";
export const SaveData = (data) => {
  return async function (dispatch) {
    return dispatch({ type: "GET_DATA", data });
  };
};
